import $ from "jquery";
var $menu = document.getElementById("navbar-burger-menu");
const $main = document.getElementById("main");

//var $hamburgerMenuButtn = document.getElementById("navbar-burger-button");
$(document).on('click', '#navbar-burger-button', function (e) {
    e.preventDefault();
    $menu.classList.toggle("hidden");
    $main.classList.toggle("blur");

});
$(document).on('click', '#navbar-burger-menu-close', function (e) {
    e.preventDefault();
    hideAllElementsAndStates();
    $menu.classList.toggle("hidden");
    $main.classList.toggle("blur");
});
$(document).on('click', '.navigation-item-link-primary', function (e) {
    const anchor = e.currentTarget.querySelector('a[href]');

    if (anchor) {
        const isClickInsideAnchor = anchor.contains(e.target);
        if (isClickInsideAnchor) {
            return;
        }
    }
    e.preventDefault();
    var guid = e.currentTarget.dataset.guid;
    hideAllElementsAndStates();
    e.currentTarget.dataset.active = true;
    var $secondaryMenuCurrent = document.getElementById("nav-secondary-menu-" + guid);
    $secondaryMenuCurrent.classList.toggle("hidden")
});
$(document).on('click', '.navbar-burger-secondary-menu-close', function (e) {
    e.preventDefault();
    hideAllElementsAndStates();
});

function hideAllElementsAndStates() {
    var $primaryMenus = document.getElementsByClassName("navigation-item-link-primary");
    for (var i = 0; i < $primaryMenus.length; i++) {
        $primaryMenus[i].dataset.active = false;
    }
    var $secondaryMenus = document.getElementsByClassName("navigation-secondary-menu");
    for (var i = 0; i < $secondaryMenus.length; i++) {
        $secondaryMenus[i].classList.add("hidden");
    }
}

// Add mouseover listner to display secondary navmenu on hover
const $primaryMenu = document.querySelector('.navbar-hidden-menu-container')
$primaryMenu.addEventListener('mouseover',(e) => {
  e.preventDefault();
  if(e.target.matches(".navigation-item-link-primary")){
    e.stopPropagation();
    e.stopImmediatePropagation();
    e.target.click();
  }
})
